import axios from 'axios';
import { logout } from '../auth';

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

const instance = axios.create({
    baseURL: API_URL,
    timeout: 15000,
});

instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['X-Api-Key'] = API_KEY;

    const viewOrgId = localStorage.getItem('viewOrgId');
    if (viewOrgId) {
        config.headers['X-View-Org-Id'] = viewOrgId;
    }

    return config;
});

instance.interceptors.response.use(
    response => response,
    error => {
        const isLoginEndpoint = error.config?.url?.includes('/auth/login');
        const skipRedirect = error.config?.skipSessionRedirect;
        if (!isLoginEndpoint && !skipRedirect && (error.response?.status === 401 || error.response?.status === 403)) {
            logout();
            window.location.href = '/login?session=expired';
        }
        if (error.code === 'ECONNABORTED') {
            error.userMessage = 'Verbindung zum Server unterbrochen. Bitte versuche es erneut.';
        }
        return Promise.reject(error);
    }
);

export default instance;
